import {createActions, createReducer} from 'reduxsauce'
import {createSelector} from 'reselect'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  moodboardSetPopinVisible: ['visible'],
  moodboardUpdateIndex: ['index']
})

export const MoodboardTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const store = {
  visible: false,
  index: 0
};

export const INITIAL_STATE = Immutable(store);

/* ------------- Reducers ------------- */
export const setPopinVisible = (state, {visible}) => state.merge({visible})
export const updateIndex = (state, {index}) => state.merge({index})

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [MoodboardTypes.MOODBOARD_SET_POPIN_VISIBLE]: setPopinVisible,
  [MoodboardTypes.MOODBOARD_UPDATE_INDEX]: updateIndex,
})

/* ------------- Selectors ------------- */

const getVisible = (state) => state.moodboard.visible;
const getIndex = (state) => state.moodboard.index;

export const selectors = {
  visible: createSelector(
    [getVisible],
    (value) => value
  ),
  index: createSelector(
    [getIndex],
    (value) => value
  )
}


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/redux/CarousselMoodboardRedux.js